var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.guideShow
    ? _c("div", { attrs: { id: "vue-ff-guide" } }, [
        _vm.focusEl
          ? _c("div", {
              staticClass: "ff-guide-focus-shape",
              style: _vm.createShapeStyle
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ff-guide-extra", on: { click: _vm.goNext } },
          [_vm._t("default")],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-156e5f4f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-156e5f4f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/core/Guide.vue
// module id = 54
// module chunks = 0